import { ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Alert } from '@mui/material';
import { DatasetDetails, Project } from '~/api/types';
import { useHasLockedStatus } from './dataset';

interface UseWbsActiveStatusOptions {
  entityLabel?: string;
  data?: DatasetDetails | Project;
  isLoading?: boolean;
}

const useWbsWarningAlert = ({ entityLabel = 'record', data, isLoading }: UseWbsActiveStatusOptions): ReactNode => {
  const datasetId = +useParams().id!;
  const projectId = +useParams().projectid!;
  const { watch } = useFormContext();
  const { hasLockedStatus } = useHasLockedStatus();
  const wbsCodeId = watch('wbs_code_id');
  const costCenterId = watch('cost_center_id');

  const isInactive =
    (wbsCodeId && !data?.wbs_code_is_active && wbsCodeId === data?.wbs_code_id) ||
    (costCenterId && !data?.cost_center_is_active && costCenterId === data?.cost_center_id);
  const isEmpty = !data?.wbs_code_id && !data?.cost_center_id;
  const hasSelection = !!(wbsCodeId || costCenterId);
  const shouldShowAlert = (isEmpty && !hasSelection) || (hasSelection && isInactive);

  if (!(datasetId || projectId) || hasLockedStatus || !shouldShowAlert || isLoading) return null;

  return (
    <Alert severity="error" sx={{ width: '100%' }}>
      The selected {costCenterId ? 'cost center' : wbsCodeId ? 'WBS' : 'WBS or cost center'} code for this {entityLabel}{' '}
      is no longer active and need to select a new one for this {entityLabel}.
    </Alert>
  );
};

export default useWbsWarningAlert;
